import { AbstractControl, FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { daysDifference, isDateInPast, isDateWithinOneYear, isEmpty } from '../utils';
import { MIN_INSURANCE_DIFF_AB } from '../form/settings';

const TravelDatesValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const formGroup = formControl as FormGroup<{
    travelDates: FormGroup<{
      dateFrom: FormControl<string | null>;
      dateTo: FormControl<string | null>;
      annual: FormControl<boolean | null>;
      with60DaysReturns: FormControl<boolean | null>;
    }>;
    isPolandIsCurrentResiding: FormControl<boolean | null>;
  }>;
  const dateFrom = formGroup.value.travelDates?.dateFrom;

  const errors: Record<string, boolean> = {};

  if (isDateInPast(formGroup.value.travelDates?.dateFrom) || !isDateWithinOneYear(formGroup.value.travelDates?.dateFrom)) {
    errors['nxDatefieldMin'] = true;
  }

  if (formGroup.value.isPolandIsCurrentResiding === false && dateFrom) {
    const dateValue = new Date(dateFrom);
    const daysDiff = daysDifference(dateValue, new Date()) || Infinity;

    if (daysDiff < MIN_INSURANCE_DIFF_AB) {
      errors['minDateFromTripAbroad'] = true;
    }
  }

  if (isEmpty(dateFrom)) {
    errors['required'] = true;
  }

  formGroup.controls.travelDates.controls.dateFrom.setErrors(!isEmpty(Object.values(errors)) ? errors : null);

  return {};
};

export default TravelDatesValidator;
